import Vue from "vue";
import VeeValidate from "vee-validate";

Vue.use(VeeValidate, {
  locale: "fr",
  dictionary: {
    fr: {
      custom: {
        email: {
          required: "L'email est obligatoire",
          email: "L'email n'est pas valide"
        },
        password: {
          required: "Le mot de passe est obligatoire"
        },
        confirm_password: {
          required: "Le mot de passe est obligatoire",
          confirmed: "Les mots de passe ne sont pas identique"
        },
        quotation: {
          mimes: "Format invalide. Seul les fichiers PDF sont autorisés"
        },
        image_upload: {
          mimes:
            "Format invalide. Seul les images png, jpg et jpeg sont autorisées"
        },
        method: {
          required: "Champ obligatoire"
        },
        renew: {
          required: "Champ obligatoire"
        },
        projectMethod: {
          required: "Champ obligatoire"
        },
        agency: {
          required: "Champ obligatoire"
        },
        product: {
          required: "Champ obligatoire"
        },
        applicator: {
          required: "Champ obligatoire"
        },
        center: {
          max: "Maximum 50 caractères"
        }
      }
    }
  }
});
